import { createAction } from '@reduxjs/toolkit';
import {
  DocumentFlowRealtimeEventPayload,
  IntegrationFlowRealTimeEventType,
  SendingFlowRealTimeEventType,
} from '../../types/realtime';

// LIFEN SENDING
export const realtimeCommunicationUpdated = createAction<DocumentFlowRealtimeEventPayload>(
  SendingFlowRealTimeEventType.COM_UPDATED,
);

export type RealtimeCommunicationRequestUpdated = typeof realtimeCommunicationRequestUpdated;
export const realtimeCommunicationRequestUpdated = createAction<DocumentFlowRealtimeEventPayload>(
  SendingFlowRealTimeEventType.CR_UPDATED,
);
export type RealtimeTrustedContactRequestUpdated = typeof realtimeTrustedContactRequestUpdated;
export const realtimeTrustedContactRequestUpdated = createAction<DocumentFlowRealtimeEventPayload>(
  SendingFlowRealTimeEventType.TRUSTED_CONTACT_CR_UPDATED,
);

// LIFEN INTEGRATIONS
export const integrationRealtimeCommunicationUpdated =
  createAction<DocumentFlowRealtimeEventPayload>(
    IntegrationFlowRealTimeEventType.INTEGRATION_COM_UPDATED,
  );

export type IntegrationRealtimeCommunicationRequestUpdated =
  typeof integrationRealtimeCommunicationRequestUpdated;
export const integrationRealtimeCommunicationRequestUpdated =
  createAction<DocumentFlowRealtimeEventPayload>(
    IntegrationFlowRealTimeEventType.INTEGRATION_CR_UPDATED,
  );

// PUBLIPOSTAGE
export const realtimePublipostageCrCreated = createAction<DocumentFlowRealtimeEventPayload>(
  SendingFlowRealTimeEventType.PUBLIPOSTAGE_CR_CREATED,
);

// ERRORS COUNT NOTIFICATIONS
export type RealtimeErrorsCountChanged = typeof realtimeErrorsCountChanged;
export const realtimeErrorsCountChanged = createAction<{
  workspace_reference: string;
  sender_reference: string;
  delta: number;
}>(SendingFlowRealTimeEventType.ERRORS_COUNT_CHANGED);
